import { Layout } from 'antd';
import { FC, ReactNode } from 'react';
import { Done } from '@material-ui/icons';
import Close from '@material-ui/icons/Close';
import camelCaseToTitleCase from 'src/helpers/camelCaseToTitleCase';
import { getAvailableKeys } from '../Profile/helpers';
import { valueType } from '../../helpers';

interface DevicesProps {
  data: any;
}

interface ObjDataInterface {
  [key: string]: any;
}

function createElement(titleText: string | undefined, bodyText: string | ReactNode | undefined) {
  return (
    <div key={`${titleText}-${bodyText}`}>
      {titleText && (
        <h4
          style={{
            color: '#9BA0AD',
            fontFamily: 'Poppins',
            fontSize: '12px',
            lineHeight: '100%',
            wordBreak: 'break-word'
          }}
        >
          {camelCaseToTitleCase(titleText)}
        </h4>
      )}
      {bodyText && (
        <p
          style={{
            fontFamily: 'Poppins',
            fontSize: '18px',
            fontWeight: 500,
            wordBreak: 'break-word'
          }}
        >
          {bodyText}
        </p>
      )}
    </div>
  );
}

function compareFn(a: string, b: string, data: ObjDataInterface): number {
  const typeA = valueType(data[a]);
  const typeB = valueType(data[b]);

  if (typeA === 'object' && typeB !== 'object') return 1;
  if (typeA !== 'object' && typeB === 'object') return -1;
  if (typeA === 'object' && typeB === 'object') return 0;

  return 0;
}

function displayNestedElements(
  data: any,
  passedKey: string | undefined,
  nestedCount: number,
  isCurrentItemFirstObj: boolean
) {
  const dataType = valueType(data);

  if (!data && dataType !== 'number' && dataType !== 'boolean') {
    // possible values => undefined, null, NaN, ""
    return createElement(passedKey, '-');
  }

  if (dataType === 'string' || dataType === 'number') {
    return createElement(passedKey, String(data));
  }

  if (dataType === 'boolean') {
    return createElement(passedKey, data ? <Done /> : <Close />);
  }

  if (dataType === 'array') {
    if (data.length === 0) {
      return createElement(passedKey, '-');
    }

    let displayData = "Can't Display Data";
    const isArrayOfStrings = data.every((item: string) => typeof item === 'string');
    if (isArrayOfStrings) {
      displayData = data.join(', ');
    }

    return createElement(passedKey, displayData);
  }

  if (dataType === 'object') {
    const availableKeys = getAvailableKeys(data, []);

    if (availableKeys.length === 0) {
      return createElement(passedKey, '-');
    }

    const sortedAvailableKeys = availableKeys.sort((a: string, b: string): number =>
      compareFn(a, b, data)
    );
    const firstNoneEmptyObjIndex = sortedAvailableKeys.findIndex(
      (key) => valueType(data[key]) === 'object' && Object.keys(data[key]).length !== 0
    );

    const reactElement = sortedAvailableKeys.map((key, index) => {
      const objKey = key;
      const objValue = data[objKey];
      const isCurrentItemFirstObj = firstNoneEmptyObjIndex === index;

      return displayNestedElements(objValue, objKey, nestedCount + 1, isCurrentItemFirstObj);
    });

    return (
      <div
        key={`customers-profile-section-${nestedCount}-${passedKey}`}
        className={`customers-profile-section-${nestedCount} ${
          isCurrentItemFirstObj ? 'first-element' : ''
        }`}
      >
        {passedKey && <h4 style={{ fontFamily: 'Poppins', fontSize: '28px' }}>{passedKey}</h4>}
        {reactElement}
      </div>
    );
  }
}

const Devices: FC<DevicesProps> = ({ data }) => {
  const CustomerDevices = () => {
    if (!data) return null;

    return (
      <div className="customers-profile">{displayNestedElements(data, undefined, 1, true)}</div>
    );
  };

  return (
    <Layout
      style={{
        background: 'white',
        borderTop: '1px solid #9BA0AD',
        marginTop: '20px'
      }}
    >
      <div
        style={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          padding: '35px 40px 0px 35px'
        }}
      >
        <div
          style={{
            fontFamily: 'Poppins',
            fontSize: '38px'
          }}
        >
          Devices
        </div>
      </div>

      <div
        style={{
          padding: '0px 40px 0px 35px',
          textAlign: 'start'
        }}
      >
        <CustomerDevices />
      </div>
    </Layout>
  );
};

export default Devices;
